export default {
    init() {
        this.packageInnerTableToggle();
    },

    packageInnerTableToggle(){
        $('.package--info-wrap').on('click', function() {
            let row = $(this).closest('tr');
            let packageLink = row.data("package");
            if (row.hasClass('active')) {
                row.removeClass('active')
                $('.package-inner[data-package-inner=' + packageLink + ']').addClass('hidden');
            } else {
                row.addClass('active')
                $('.package-inner[data-package-inner=' + packageLink + ']').removeClass('hidden');
            }
        });
    },
}